import { Colors } from "@jsq/ds/styles";
import { ComplianceStatusCategory } from "../types";

export type StatusConfig = {
  category: ComplianceStatusCategory;
  label: string;
  color: string;
  tooltip: string;
};

export const STATUS_CONFIG: StatusConfig[] = [
  {
    category: "compliant",
    label: "Compliant",
    color: Colors.Success500,
    tooltip:
      "Positions are currently compliant with no outstanding actions. This includes screening, document or profile refreshes, onboarding, domicile risks, or risk ratings.",
  },
  {
    category: "reviewNotStarted",
    label: "Review not started",
    color: Colors.Informative500,
    tooltip:
      "Positions are currently pending a compliance onboarding case and has not yet been processed with Fund Administration. No action is required from you.",
  },
  {
    category: "inJSQReview",
    label: "Juniper Square review",
    color: Colors.Informative600,
    tooltip:
      "Positions are currently being processed and active cases are open with Fund Administration. No action is required from you.",
  },
  {
    category: "inLPSubmission",
    label: "LP submission",
    color: "#D1913D",
    tooltip: "Positions have active open cases and  pending action from LP.",
  },
  {
    category: "pendingDivestment",
    label: "Pending divestment",
    color: Colors.Warning600,
    tooltip:
      "The client has rejected the escalation. As a result, this position is slated for removal from the investment.",
  },
];
